import {LINKMAKER_BASE, LINKMAKER_REPLACE} from "../library/constants";

function Linkmaker (link:string){
    return (link.replace(LINKMAKER_REPLACE,LINKMAKER_BASE));
}

export default Linkmaker;
